import type { IImportCSVMintFailure } from "@redbelly-tokeniser/mystake-api-sdk";
import React from "react";
import { Button, DataTable, Modal } from "../../designSystem";

type CsvImportMintFailuresDialogProps = {
  open: boolean;
  failures: IImportCSVMintFailure[];
  onClose: () => void;
};

export const CsvImportMintFailuresDialog: React.FC<CsvImportMintFailuresDialogProps> = ({
  open,
  failures,
  onClose,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title="Token minting issues"
    width={720}
    footer={
      <Button variant="outline" size="sm" onClick={onClose}>
        Close
      </Button>
    }
  >
    <p style={{ marginBottom: 12 }}>
      The register was imported, but token minting failed for the following transaction(s). You can retry minting from
      the register or contact support if the problem persists.
    </p>
    <div
      className="u-border u-radius-xs"
      style={{
        maxHeight: 360,
        overflow: "auto",
        marginBottom: 16,
      }}
    >
      <DataTable
        columns={[
          { key: "context", label: "Transaction Info", wrap: true },
          { key: "message", label: "Error", wrap: true },
        ]}
        rows={failures.map((row, index) => ({ ...row, rowKey: `${row.context}-${index}` }))}
        rowKey="rowKey"
      />
    </div>
  </Modal>
);
